// extracted by mini-css-extract-plugin
export var footer = "_od-5";
export var fulfillmentInput = "_od-0";
export var shipDateInput = "_od-1";
export var shipmentModal = "_od-2";
export var shipmentModalContent = "_od-3";
export var tableContainer = "_od-4";